import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import chevLeft from 'icons/chevron-left-24.png';
import pencilEdit from 'icons/pencil-edit-24.png';
import ConfirmModal from '../common/ConfirmModal';
import { getIngredient } from 'helpers/ingredientHelpers';
import { lookupMed } from 'helpers/medicationHelpers';

export default function IngredientDetails(props) {
    const [popup, setPopup] = useState({
        show: false,
        confirm: 'Delete',
        medName: 'tempName',
        id: null,
      });
      const navigate = useNavigate();
      const params = useParams();
      //console.log('IngredientDetails', params);
      const iId = params.inqId;
      const mId = params.medId;
      const ing = getIngredient(iId);
      const med = lookupMed(mId);
      console.log('IngredientDetails', iId, mId);


  function deleteIngredient() {
  }

  function handleDeleteTrue() {
  }

  function handleDeleteFalse() {
  }

  function edit(item) {
    console.log('edit', item.title);
  }

  function EditIcon(title) {
    return (
        <img src={pencilEdit} alt='' className="hover:cursor-pointer" onClick={()=>edit(title)}/>
        );
  }

  return (
    <div className='mcard'>
      <ConfirmModal
        open={popup.show} 
        confirmButton={popup.confirm}
        onConfirm={()=>handleDeleteTrue()}
        onCancel={()=>handleDeleteFalse()}
        title={popup.medName}
        content={popup.taken}
        />
      <div className='mcard-screen flex justify-between'>
          <div className='flex flex-row items-center'>
            <div className='hover:cursor-pointer' onClick={()=>navigate(-1)}>
              <img src={chevLeft} alt='' />
            </div>
            <div className='pl-4'>
              <div>Ingredient details for</div>
              <div>{med.name}</div>
              <div>{ing.name}</div>
            </div>
          </div>
        </div>
        <div className='py-2 flex justify-center  min-w-full px-4 phone:px-6 tablet:px-8'>
        <table className='ingTable'>
          <tbody className='ingTbody'>
            <tr>
              <td>Name</td>
              <td>{ing.name}</td>
              <td><EditIcon title='name'/></td>
            </tr>
            <tr>
              <td>Quantity</td>
              <td>{ing.quantity}</td>
              <td><EditIcon title='quantity'/></td>
            </tr>
            <tr>
              <td>Unit</td>
              <td>{ing.unit}</td>
              <td><EditIcon title='unit'/></td>
            </tr>
            <tr>
              <td>Notes</td>
              <td>{ing.notes}</td>
              <td><EditIcon title='notes'/></td>
            </tr>
            <tr>
              <td>Category</td>
              <td>{ing.category}</td>
              <td><EditIcon title='category'/></td>
            </tr>
            <tr>
              <td>Unii Code</td>
              <td>{ing.uniiCode}</td>
              <td><EditIcon title='uniiCode'/></td>
            </tr>
            <tr>
              <td>Label Id</td>
              <td>{ing.labelId}</td>
              <td><EditIcon title='uniiCode'/></td>
            </tr>
          </tbody>
        </table>
      </div>
        <div>
            <div className='flex flex-row flex-grow justify-around items-center'>
                {/* <button
                onClick={() => editIngredient(i.id)}
                className='rawBtn h-full w-[40%] mr-2 py-1 px-2 bg-yellow-600 text-white'
                > 
                Edit
                </button> */}
                <button
                onClick={() => deleteIngredient()}
                className='rawBtn w-20 h-[80%] py-1 px-2 bg-red-700 text-white'
                > 
                Delete
                </button>
            </div>
        </div>
    </div>
  )
}

